import styled from 'styled-components';

import { GridItem } from '@xing-com/grid';
import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceXXL, scale180 } from '@xing-com/tokens';

export const DesktopOnlyGridItem = styled(GridItem)`
  display: none;

  @media ${mediaConfined} {
    margin-top: ${spaceXXL};
    display: block;
  }
`;

export const LanguagesGridItem = styled(GridItem)`
  margin-top: ${scale180};
`;

export const SideIllustration = styled.img`
  margin: calc(154px - 32px) 0;
  width: 100%;
`;

export const Illustration = styled.img`
  margin-top: ${spaceXXL};
  width: 100%;
`;
